import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { HiddenCost } from './components/HiddenCost';
import { Transformation } from './components/Transformation';
import { ThisIsForYou } from './components/ThisIsForYou';
import { PackContent } from './components/PackContent';
import { Bonus } from './components/Bonus';
import { MainOffer } from './components/MainOffer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '794641966815768');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans selection:bg-terracotta/30" data-id="element-0">
      <Hero data-id="element-1" />
      <HiddenCost data-id="element-2" />
      <Transformation data-id="element-3" />
      <ThisIsForYou data-id="element-4" />
      <PackContent data-id="element-5" />
      <Bonus data-id="element-6" />
      <MainOffer data-id="element-7" />
      <Guarantee data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}